import { motion } from "framer-motion";
import { Briefcase, MapPin, Clock, ArrowRight } from "lucide-react";

const JobCard = ({ job, onSelect }) => {
  return (
    <motion.div
      key={job.id}
      className="group relative p-8 border border-border bg-card/30 backdrop-blur-sm hover:border-cyan-400/50 transition-all duration-300 cursor-pointer"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 * job.id }}
      whileHover={{ y: -4 }}
      onClick={() => onSelect(job)}
    >
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <span className="px-2 py-0.5 bg-muted text-muted-foreground text-[10px] font-mono uppercase tracking-wider border border-border">
              {job.department}
            </span>
            <span className="text-cyan-400 text-[10px] font-mono uppercase tracking-wider flex items-center gap-1">
              <Clock className="w-3 h-3" />
              {job.type}
            </span>
          </div>
          <h3 className="text-foreground font-mono font-bold text-xl mb-3 group-hover:text-cyan-400 transition-colors">
            {job.title}
          </h3>
          <p className="text-muted-foreground text-sm mb-4 max-w-2xl">
            {job.description}
          </p>
          <div className="flex items-center gap-4 text-muted-foreground/60 text-xs">
            <span className="flex items-center gap-1">
              <MapPin className="w-3 h-3" />
              {job.location}
            </span>
          </div>
        </div>
        
        <motion.button
          className="neon-button text-xs whitespace-nowrap"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={(e) => {
            e.stopPropagation(); // Prevent onSelect from firing twice
            onSelect(job);
          }}
        >
          View Details
          <ArrowRight className="ml-2 w-4 h-4" />
        </motion.button>
      </div>
      
      {/* Hover Accent */}
      <div className="absolute inset-0 opacity-0 group-hover:opacity-5 bg-gradient-to-br from-cyan-400 to-transparent pointer-events-none transition-opacity" />
    </motion.div>
  );
};

export default JobCard;
